// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f29e8920","455":"4f331f1f","977":"9bc32e18"}[chunkId] + ".chunk.js";
};